import QRCode from "qrcode";

export async function renderQrCode(container: HTMLElement, text: string): Promise<void> {
    const canvas = document.createElement("canvas");
    container.replaceChildren(canvas);
    await QRCode.toCanvas(canvas, text, { width: 200, margin: 1 });
}
